import { EntrySingletonPageShared } from '../../EntrySingletonPageShared.ts';
import '../../css/style.scss';
import { UIWHeaderController } from '../ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from '../ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { mountMorePage } from '../../../shared/scripts/more/mountMorePage.ts';
import { UIPopupRulebook } from '../../../shared/scripts/ui_popup/UIPopupRulebook.ts';
import { RulebookPage } from '../../../../shared/enums/RulebookEnums.ts';
class EntryMore extends EntryShared {
    static async init() {
        EntryShared.initializeAudio();
        await EntryShared.initializeEntry();
        const headerController = new UIWHeaderController();
        new UISidebarController();
        mountMorePage('more-page-container', ()=>new UIPopupRulebook(RulebookPage.Classic4P).show());
        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
    }
    constructor(){
        super();
        void EntryMore.init();
    }
}
new EntryMore();
